/**
 * Full name from FAI inspection `evaluator` (account firstname/lastname), when present.
 */
export function formatFAIEvaluatorDisplayName(inspection) {
  if (!inspection?.evaluator) {
    return '';
  }
  const { firstname = '', lastname = '' } = inspection.evaluator;
  return `${firstname} ${lastname}`.trim();
}
